import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateClient } from "api/client.api";
import {
  invalidateClientSide,
  invalidateDashboardSources,
} from "lib/cacheInvalidation";

export const useUpdateClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...body }) => updateClient(id, body),
    onSuccess: () => {
      invalidateClientSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
